import React from 'react';
import { APP_IMG } from 'src/constants';
import styled from 'styled-components';

function SectionOne() {
  return (
    <SectionWrapper className='section-one' background={`${APP_IMG}/images/hangover/section-background-desktop.png`}>
      <div className='container content'>
        <img className='svg-logo' src='https://thepeople.my.canva.site/hang-over/images/e4942d01a7cc6938322b478b8463a4b9.svg' />
        <div className='info-wrapper'>
          <img className='title-image' src={`${APP_IMG}/images/hangover/section-1-title.png`} />
          <div className='des-text'>วงเสวนาแสนรื่นรมย์ว่าด้วยเรื่องความเมาและความเท่าเทียม</div>
        </div>
        <div className='address'>24 APRIL 2023, Gaysorn Urban Resort</div>
        <div className='qr-wrapper'>
          <div className='qr-text'>SCAN ลงทะเบียนร่วมงาน</div>
          <img className='qrcode' src={`${APP_IMG}/images/hangover/qr-code.png`} />
        </div>
      </div>
    </SectionWrapper>
  );
}
interface StyledProps {
  background: string;
}
const SectionWrapper = styled.div<StyledProps>`
  position: relative;
  /* background-color: red; */
  width: 100%;
  margin: auto;
  height: auto;
  background-image: url(${props => props?.background});
  background-size: contain;
  background-position: bottom;
  background-repeat: no-repeat;
  background-color: #f9f9f9;
  padding: 25px 0;
  @media (max-width: 992px) {
    background-size: cover;
    padding: 40px 0;
  }
  .content {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 50px;
    @media (max-width: 992px) {
      padding: 0 15px;
    }
    .svg-logo {
      width: 30%;
      @media (max-width: 992px) {
        width: 35%;
      }
      @media (max-width: 475px) {
        width: 70%;
      }
    }

    .info-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
      .title-image {
        width: 50%;
        @media (max-width: 992px) {
          width: 65%;
        }
        @media (max-width: 475px) {
          width: 90%;
        }
      }
      .des-text {
        text-align: center;
        font-size: 24px;
        font-weight: 600;
        @media (max-width: 992px) {
          font-size: 20px;
        }
        @media (max-width: 475px) {
          font-size: 14px;
          font-weight: 500;
        }
      }
    }
    .address {
      text-align: center;
      font-size: 24px;
      font-weight: 600;
      @media (max-width: 992px) {
        font-size: 22px;
      }
      @media (max-width: 475px) {
        font-size: 18px;
      }
    }
    .qr-wrapper {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .qr-text {
        width: fit-content;
        text-align: center;
        font-size: 18px;
        font-weight: 500;
        @media (max-width: 992px) {
          font-size: 18px;
        }
      }
      .qrcode {
        width: 20%;
        @media (max-width: 992px) {
          width: 25%;
        }
        @media (max-width: 475px) {
          width: 45%;
        }
      }
    }
  }
`;
export default SectionOne;
